var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 150,
    viewBox: "0 0 281 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1926 92.1854L143.437 79.1987C144.421 79.029 145.019 80.2463 144.283 80.921L109.658 112.693C109.584 112.76 109.506 112.816 109.412 112.852C106.285 114.036 94.6773 109.408 88.2755 106.506C87.7107 106.25 87.0517 106.559 86.8827 107.156C85.4666 112.155 83.7937 116.758 82.878 119.086C82.7048 119.527 82.2193 119.75 81.9437 119.365C80.3647 117.162 80.1332 107.955 80.243 102.475C80.2533 101.963 79.8779 101.529 79.3769 101.42C74.7192 100.409 68.5338 96.3137 65.8809 94.2724",
    stroke: "#5D44FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0166 105.336C95.9889 101.535 116.157 92.0157 133.052 84.345",
    stroke: "#5D44FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9102 119.838L96.7946 110.297",
    stroke: "#5D44FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3447 98.0842L105.954 90.8328",
    stroke: "#5D44FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7942 132.661C66.2247 136.751 45.5603 141.122 23.459 125.883",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.584 123.283C49.9655 121.399 19.9828 110.132 1.00008 80.1355",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.095 8.24112C200.161 4.35948 176.255 26.4259 171.105 58.1764C165.956 89.927 181.663 118.418 205.597 122.3C229.531 126.181 253.438 104.115 258.587 72.3643C263.736 40.6138 248.029 12.1228 224.095 8.24112Z",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.272 20.7661C211.515 19.3458 202.731 22.8306 195.598 29.7731C188.466 36.7155 183.041 47.0728 181.073 59.2092C179.104 71.3456 180.978 82.8865 185.55 91.7273C190.123 100.568 197.355 106.65 206.112 108.071C214.869 109.491 223.652 106.006 230.785 99.0634C237.917 92.121 243.343 81.7639 245.311 69.6275C247.28 57.4911 245.405 45.9501 240.832 37.1092C236.259 28.2685 229.028 22.1863 220.272 20.7661Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9076,
    cy: 22.7973,
    rx: 16.9076,
    ry: 22.7973,
    transform: "matrix(-0.987103 -0.160089 -0.160089 0.987103 230.437 45.1072)",
    fill: "#38D000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.947 116.404C218.415 145.791 184.447 128.617 177.196 110.107C180.425 128.57 202.304 139.046 220.514 139.494C240.55 139.494 265.549 122.892 272.418 107.817C297.699 52.3408 259.188 13.2942 239.978 7.82397C276.044 24.8075 281.761 84.8198 248.947 116.404Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSend);
export default __webpack_public_path__ + "static/media/email-send.852db93534860d3c576d4c4dd500be19.svg";
export { ForwardRef as ReactComponent };